import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "./index.css";
import App from "./App";
import { handleIncomingModuleToken } from "./components/layout/ModuleSwitcher";

axios.defaults.withCredentials = true;

const nativeFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => nativeFetch(input, { credentials: "include", ...init });

handleIncomingModuleToken();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
